import React from 'react';

const SubTitle = ({ title, children }) => {
  return <h1 className="title-font text-lg font-medium text-yellow-200 mb-3">
    {title || children}
  </h1>
};

export default SubTitle;